const CRORE = 10000000;
const LAC = 100000;
const THOUSAND = 1000;

const trimTrailingZeros = (value) => {
    const formatted = new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(value);
    return formatted;
};

export const formatTakhmeenAmount = (value) => {
    const amount = parseFloat(value);
    if (value === null || value === undefined || value === "" || Number.isNaN(amount)) return "-";

    const sign = amount < 0 ? "-" : "";
    let remaining = Math.abs(Math.round(amount * 100) / 100);
    if (remaining === 0) return `${sign}₹ 0`;

    const parts = [];

    const crs = Math.floor(remaining / CRORE);
    if (crs > 0) {
        parts.push(`${crs} Cr${crs !== 1 ? "s" : ""}`);
        remaining = Math.round((remaining - crs * CRORE) * 100) / 100;
    }

    const lacs = Math.floor(remaining / LAC);
    if (lacs > 0) {
        parts.push(`${lacs} Lac${lacs !== 1 ? "s" : ""}`);
        remaining = Math.round((remaining - lacs * LAC) * 100) / 100;
    }

    const thousands = Math.floor(remaining / THOUSAND);
    if (thousands > 0) {
        parts.push(`${thousands} Thousand`);
        remaining = Math.round((remaining - thousands * THOUSAND) * 100) / 100;
    }

    if (remaining > 0 || parts.length === 0) {
        parts.push(trimTrailingZeros(remaining));
    }

    return `${sign}₹ ${parts.join(" ")}`;
};
